import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-bit-not-set',
  templateUrl: './bit-not-set.component.html',
  styleUrls: ['./bit-not-set.component.scss']
})
export class BitNotSetComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<BitNotSetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    
  }

  ngOnInit(): void {
  }

  onClose(event) {

    this.dialogRef.close();
  }

}
